import { Divider, Paper } from '@mui/material';
import { MemreButton, MemreFlexBox } from 'components/core';
import { MemreRTE } from 'components/core';

export default function SurveyAnswers({ text, id, image, deleteAnswer, updateAnswer, handleAddImage }) {
  const disabled = id.includes('placeholder');

  return (
    <Paper
      component="form"
      sx={{
        p: '2px 8px 2px 4px',
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #767676',
        opacity: disabled ? 0.3 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      <MemreFlexBox direction="column" sx={{ flex: 1 }}>
        <MemreRTE initialContent={text} onUpdate={updateAnswer} placeholder="Answer Text" id={`$answer-${id}`} />
      </MemreFlexBox>
      <Divider sx={{ height: '70%', m: 0.5 }} orientation="vertical" />
      {image?.url && (
        <MemreFlexBox direction="column" sx={{ position: 'relative', height: '100%' }} align="center" justify="center">
          <div
            style={{
              aspectRatio: '1/1',
              height: '100%',
              backgroundImage: `url(${image.url})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              borderRadius: '4px',
            }}
          />
          <MemreButton
            variant="icon"
            iconName="trash"
            onClick={image.delete}
            sx={{ position: 'absolute', backgroundColor: 'white' }}
          />
        </MemreFlexBox>
      )}
      {!image?.url && <MemreButton variant="icon" iconName="image" onClick={() => handleAddImage(image.add)} />}
      <MemreButton variant="icon" iconName="trash" onClick={deleteAnswer} />
    </Paper>
  );
}
